export default {
      id: "icon-confetti-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-confetti",
      toString: function () {
        return this.url;
      }
    }